import BasePageMixin from 'vue-template/common/mixins/BasePageMixin';
import { toQueryString } from 'core/http/HttpService';

export default {
  mixins: [BasePageMixin],

  data() {
    return {
      parameters: {}, //this.initParameters(),
      pageRequest: {
        number: 0,
        size: 25
      },
      sort: {
        order: 'id'
      },
      page: null,
    };
  },

  computed: {
    pageSizeOptions() {
      return [
        { value: 0, text: this.$t('common.all') },
        { value: 3, text: '3' },
        { value: 5, text: '5' },
        { value: 25, text: '25' },
        { value: 50, text: '50' },
      ];
    },
  },

  watch: {
    $route: 'handleQueryParameters'
  },

  async mounted() {
    this.$emit('breadcrumbs', this.breadcrumbs());
    //await this.find();
    await this.handleQueryParameters();
  },

  methods: {
    /*
    initParameters() {
      return {};
    },
    */

    convertParameter(name, value) {
      return value;
    },

    breadcrumbs() {
      throw Error('breadcrumbs() method not implemented');
    },

    getService() {
      throw Error('getService() method not implemented');
    },

    debug(...args) {
      console.log('DEBUG', ...args);
    },

    hideModal() {
      this.$refs.modal.hide();
    },

    async find() {
      console.log('Finding');

      let query = toQueryString({
        ...this.parameters,
        ...this.pageRequest,
        ...this.sort
      });

      if (query) {
        query = '?' + query;
      }

      //console.log('Query', this.$route, query);

      this.$router.push(
        this.$route.path + query
      );

      /*
      try {
        const { data } = await this.getService().find({
          parameters: this.parameters,
          pageRequest: this.pageRequest,
          sort: this.sort
        });
        this.page = data;
      } catch (e) {
        await this.handleError(e);
      }
      console.log('page', this.page);
      if (this.$refs.modal) {
        this.$refs.modal.hide();
      }
      */
    },

    getParametersFromQuery(q) {
      //console.log("getParametersFromQuery", q);
      const ret = {};
      for (let k of Object.keys(q)) {
        //console.log("k", k);
        let target = ret;
        const value = this.convertParameter(k, q[k]);
        const splitted = k.split(".");
        const splittedLen = splitted.length;
        let i = 0;
        for (; i < splittedLen - 1; i++) {
          const s = splitted[i];
          //console.log("\t", s);
          if (target[s] === undefined) {
            target[s] = {};
          }
          target = target[s];
        }
        const s = splitted[i];
        //console.log("\t*", s);
        if (target[s] === undefined) {
          target[s] = value;
        } else if (Array.isArray(target[s])) {
          target[s].push(value);
        } else {
          target[s] = [ target[s], value ];
        }
      }
      return ret;
    },

    async handleQueryParameters() {
      const q = { ...this.$route.query };

      const { number, size, sort, order } = q;

      delete q.number;
      delete q.size;
      delete q.sort;
      delete q.order;

      console.log('q', q);

      try {
        const pageRequest = {
          number: number === undefined ? 0 : number,
          size: size === undefined ? 25 : size,
        };

        const { data } = await this.getService().find({
          parameters: q,
          pageRequest,
          sort: { sort, order }
        });
        this.page = data;
        this.pageRequest = pageRequest;
        this.parameters = this.getParametersFromQuery(q);
      } catch (e) {
        await this.handleError(e);
      }
      console.log('page', this.page);
      if (this.$refs.modal) {
        this.$refs.modal.hide();
      }
    },

    async selectPageSize(size) {
      //console.log('pageSize', size);
      if (!this.page || this.page.size !== size) {
        this.pageRequest = {
          ...this.pageRequest,
          size,
          number: 0,
        };
        await this.find();
      }
    },

    async selectPage(number) {
      //console.log('pageNumber', number);
      this.pageRequest = {
        ...this.pageRequest,
        number
      };
      await this.find();
    },

    async sortBy(sort, order) {
      this.sort = { sort, order };
      await this.find();
    },
  }
};
